import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import ContactForm from "./components/ContactForm/ContactForm";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import TabsPages from "./components/TabsPages/TabsPages";
import PageSEO from "./components/PageSeo/PageSeo";

const CURRENT_VERSION = "0.22";

const Layout = () => {
  const location = useLocation();
  const [isBlocked, setIsBlocked] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const isNavigationPage = location.pathname.startsWith("/navigation");
  const isApplyOnline = location.pathname.startsWith("/apply-online");
  const isPage404 = location.pathname.startsWith("/page-not-found");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const storedCheckRaw = localStorage.getItem("geoCheck");

    if (storedCheckRaw) {
      try {
        const { isBlocked: storedBlocked, timestamp, version } = JSON.parse(storedCheckRaw);
        const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000;
        const isVersionChanged = version !== CURRENT_VERSION;

        if (!isExpired && !isVersionChanged) {
          if (storedBlocked) {
            // window.location.href = "https://maltasmb.com/";
            return;
          } else {
            setIsChecked(true);
            return;
          }
        }
      } catch (e) {
        // Если ошибка чтения JSON — проигнорируем и сделаем новую проверку
      }
    }

    // Новая проверка
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const blockedCountries = [
          "AL",
          "AD",
          "AT",
          "BY",
          "BE",
          "BA",
          "BG",
          "HR",
          "CY",
          "CZ",
          "DK",
          "EE",
          "FI",
          "FR",
          "DE",
          "GR",
          "HU",
          "IS",
          "IE",
          "IT",
          "LV",
          "LI",
          "LT",
          "LU",
          "MT",
          "MD",
          "MC",
          "ME",
          "NL",
          "MK",
          "NO",
          "PL",
          "PT",
          "RO",
          "RU",
          "SM",
          "RS",
          "SK",
          "SI",
          "ES",
          "SE",
          "CH",
          "TR",
          "GB",
          "VA",
        ];

        const blocked = blockedCountries.includes(data.country);

        localStorage.setItem(
          "geoCheck",
          JSON.stringify({
            isBlocked: blocked,
            timestamp: Date.now(),
            version: CURRENT_VERSION,
          })
        );

        if (blocked) {
          window.location.href = "https://blocked.example.com";
        } else {
          setIsChecked(true);
        }
      })
      .catch(() => {
        setIsChecked(true); // при ошибке не блокируем
      });
  }, []);

  if (isBlocked) return null;
  if (!isChecked) return null;

  return (
    <>
      <PageSEO />
      {!isNavigationPage && <Header />}
      <Outlet />
      {!isNavigationPage && !isApplyOnline && !isPage404 && <Footer />}
      {!isNavigationPage && !isApplyOnline && !isPage404 && window.innerWidth >= 768 && (
        <ContactForm />
      )}
      {!isNavigationPage && window.innerWidth <= 767 && <TabsPages />}
    </>
  );
};

export default Layout;
